import Marionette from 'backbone.marionette';
import storyItemviewTmpl from '../templates/story_itemview.tpl';
export default Marionette.ItemView.extend({
  template: storyItemviewTmpl,
  tagName: "li",
  className: "story-list-item"
});